// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2FAa2","footer":"ModalCreateQualiphyProcedure_footer__2rd91","additionData":"ModalCreateQualiphyProcedure_additionData__1aWjy"};